import { Component } from 'react'
import { connect } from 'react-redux'

import ErrorAlert from 'components/error/alert'
import { handleScheduleError, dismissScheduleError } from 'actions/errors'
import { eventBaseErrorsSelector } from 'selectors'
import { useTelemetry } from 'contexts/TelemetryContext'
import { withI18n } from 'locales'

const withTelemetry = (WrappedComponent) => (props) => {
  const telemetry = useTelemetry()
  return <WrappedComponent {...props} telemetry={telemetry} />
}

class BookingError extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.error && this.props.error) {
      this.props.telemetry.refreshTelemetry()
    }
  }

  renderEventBaseError() {
    switch (this.props.eventBaseError.key) {
      case 'spot_already_filled':
        return (
          <ErrorAlert
            title={this.props.i18n.t('errors.booking.spot.alert_error.title')}
            text={this.props.i18n.t('errors.booking.spot.alert_error.text')}
            buttonText={this.props.i18n.t('errors.booking.spot.alert_error.button')}
            buttonClick={() => this.props.handleError(this.props)}
            error={this.props.error}
            dismissError={this.props.dismissError}
          />
        )
      case 'poll_votes_failure':
        return (
          <ErrorAlert
            text={this.props.i18n.t('booking.error.poll_votes_failure')}
            error={this.props.error}
            dismissError={this.props.dismissError}
          />
        )
      default:
        return (
          <ErrorAlert
            error={this.props.error}
            dismissError={this.props.dismissError}
          />
        )
    }
  }

  render() {
    if (!this.props.error) return null

    switch (this.props.error.type) {
      case 'validation':
        if (this.props.eventBaseError) {
          return this.renderEventBaseError()
        }
        return null

      default:
        return (
          <ErrorAlert
            error={this.props.error}
            dismissError={this.props.dismissError}
          />
        )
    }
  }
}

const mapStateToProps = (state) => ({
  error: state.scheduling.error,
  eventBaseError: eventBaseErrorsSelector(state),
})

const mapDispatchToProps = {
  handleError: handleScheduleError,
  dismissError: dismissScheduleError
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n(withTelemetry(BookingError)))
